import { Component, EventEmitter, Inject, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwContainerOptions, DwContext, DwExpressionService, DwFormActionInterceptResult, DwFormActionInterceptor, DwFormActionKeys, DwFormContextMode, DwItemAttribute, DwLoggingService, DwMdFormContextInfo, DwMessage, DwMessageSeverity, DwMetaDataFormApi, DwMetaDataFormConfig, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwSectionBasePreference, DwUIMetaDataConfig, DwUIMetaDataConfigToken, DwUiConfigRegistryService, deepCopy, formatDateTimeFromLocal, removeNullProperties } from '@devwareapps/devware-cap';
import { combineLatest, Observable, of, Subscription } from 'rxjs';
import { AcsTestCheckRideTypeEntity, AppMetaData, AppMetaDataItemNames, ApplicantPlaceholderEntity, CheckRideApplicantTypeAllItems, CheckRideExaminerTypeAllItems, CheckRideInstructorTypeAllItems, CheckRideOutcomeAllItems, CheckRideRequestEntity, CheckRideRequestSubStatusAllItems, CheckRideResultEntity, CheckRideScenarioEntity, CheckRideWorkflowAllItems, FlightSchoolApplicantEntity, FlightSchoolApplicantStatusAllItems, FlightSchoolExaminerEntity, FlightSchoolExaminerTypeAllItems, FlightSchoolExaminerWithExaminerDetailsQueryEntity, FlightSchoolTypeAllItems, PilotExaminerLocationEntity, PilotExaminerSearchQueryEntity, SchoolFeatureAllItems } from '../../../../meta-data/app-meta-data.service';

import { debounceTime, mergeMap, pairwise, tap } from 'rxjs/operators';

import { PlanOfActionRepositoryService } from '../../../plan-of-action/services/plan-of-action-repository.service';
import { CheckrideReferenceInfo } from '../../../examiner/models/checkride-reschedule-info.model';
import { ExaminerRepositoryService } from '../../../examiner/services/examiner-repository.service';
//import { ExaminerCheckrideVariables } from '../../../examiner/models/examiner-checkride-variables.model';
import { SchoolRepositoryService } from '../../services/school-repository.service';
import { DateTimeUtilService } from '../../../shared/util/date-time-util.service';
import { ApplicantRepositoryService } from '../../../applicant/services/applicant-repository.service';
import { SchoolCheckrideUtilService } from '../../services/school-checkride-util.service';
import { ExaminerBookingVariableContext } from '../../../booking/models/examiner-booking-variable-context.model';
import { AdminManagerService } from '../../../shared/services/admin-manager.service';
import { SchoolFeatures } from '../../models/school-features.model';
import { ChangeLogEntry, getObservableChangeLog } from '../../../shared/util/object-differ.class';

@DwComponent({
  key: 'school-check-ride-util',
  name: ' School Check Ride Util',
  componentType: DwComponentType.formSection,
  parentItemName: AppMetaDataItemNames.CheckRideRequest,
  isGlobal: false
})
@Component({
  selector: 'app-school-check-ride-util',
  template: `
    <div class="dw-red" *ngIf="showError && errorMessage">
      <dw-html-view [ngModel]="errorMessage"></dw-html-view>
    </div>
  `
})
export class SchoolCheckRideUtilComponent extends DwSectionBaseComponent {

  checkRideRequest: CheckRideRequestEntity;

  initComplete = false;
  rescheduleInfo: CheckrideReferenceInfo;
  checkrideScenarioId: number;
  currentScenario: any;
  checkRideTypeId: number;
  checkrideResultActualDateTime: string;
  formApi: DwMetaDataFormApi;
  applicantDataUpdated: boolean;
  isRebook: boolean;
  testTypeId: number;
  originalCheckRideRequest: any;
  lastCheckRideRequest: CheckRideRequestEntity;
  variableContext: ExaminerBookingVariableContext;
  lastVariableContext: ExaminerBookingVariableContext;

  allApplicants: FlightSchoolApplicantEntity[];
  allAcsTests: AcsTestCheckRideTypeEntity[];

  errorMessage: string;
  showError: boolean;
  schoolFeatures: SchoolFeatures;
  dataDiffs: any;

  showLog = false;
  schoolExaminers: FlightSchoolExaminerWithExaminerDetailsQueryEntity[];
  testTypes: any;
  outcomes: any;

  constructor(
    dwExpressionService: DwExpressionService,
    dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    private dwMetaDataFormStateService: DwMetaDataFormStateService,
    private examinerRepositoryService: ExaminerRepositoryService,
    private planOfActionRepositoryService: PlanOfActionRepositoryService,
    private schoolRepositoryService: SchoolRepositoryService,
    private dateTimeUtilService: DateTimeUtilService,
    private applicantRepositoryService: ApplicantRepositoryService,
    private schoolCheckrideUtilService: SchoolCheckrideUtilService,
    private adminManagerSerice: AdminManagerService,
    private schoolRespositoryService: SchoolRepositoryService,
    private dwLoggingService: DwLoggingService
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);

    this.formApi = this.dwMetaDataFormStateService.state.formApi;
  }

  ngOnInit(): void {
    this.loadReferenceData();
    this.setupDataWatch();

    this.setupFormActionInterceptor()
  }

  setupDataWatch() {

    const obs: Observable<any>[] = [];

    obs.push(this.formApi.getFormDataChanges(0));

    obs.push(this.formApi.getVariableContext());

    combineLatest(obs)
      .pipe(debounceTime(50))
      .subscribe(([dataChange, variableContext]) => {
        if (this.formApi.isDataLoadComplete) {
          this.checkForDataChange();
        }
      });

    if (this.formApi.isDataLoadComplete) {
      this.checkForDataChange();
    }
  }
  private loadReferenceData() {
    const pilexosUser = this.adminManagerSerice.getPilexosUser();

    const obs: Observable<any>[] = [];

    obs.push(this.schoolRespositoryService.getCurrentFlightSchoolApplicants());
    obs.push(this.planOfActionRepositoryService.getAcsTestByCheckRideTypeAll());
    obs.push(this.schoolRespositoryService.getSchoolFeatures());
    obs.push(this.schoolRepositoryService.getSchoolExaminers());

    obs.push(this.examinerRepositoryService.getCheckrideTestTypes());
    obs.push(this.examinerRepositoryService.getCheckrideOutcomes());

    combineLatest(obs)

      .subscribe(([applicants, allAcsTests, features, examiners, testTypes, outcomes]) => {
        this.allApplicants = applicants;
        this.allAcsTests = allAcsTests;
        this.schoolFeatures = features;
        this.schoolExaminers = examiners;
        this.testTypes = testTypes;
        this.outcomes = outcomes;

        if (this.formApi.isDataLoadComplete) {
          this.checkForDataChange();
        }
      });
  }

  protected checkForDataChange() {
    if (!this.allApplicants) {
      return;
    }

    const checkRideRequest = this.formApi.getFormData<CheckRideRequestEntity>();
    const variableContext = this.formApi.getVariableContextValue<ExaminerBookingVariableContext>();

    if (this.checkRideRequest && checkRideRequest && this.checkRideRequest.CheckRideRequestSubStatusId != checkRideRequest.CheckRideRequestSubStatusId) {
      switch (this.checkRideRequest.CheckRideRequestSubStatusId) {
        case CheckRideRequestSubStatusAllItems.NewDateProposedByExaminer:
          this.updateProposedInfo(checkRideRequest);
      }
    }

    if (!this.originalCheckRideRequest) {
      this.originalCheckRideRequest = checkRideRequest;
    }
    this.checkRideRequest = checkRideRequest;
    this.variableContext = variableContext;

    const checkrideUpdate: Partial<CheckRideRequestEntity> = {};
    const variableUpdate: Partial<ExaminerBookingVariableContext> = {};

    if (this.checkRideRequest.PreferredAirportId != this.lastCheckRideRequest?.PreferredAirportId) {
      this.schoolDebug(`Airport Changed from ${this.lastCheckRideRequest?.PreferredAirportId || 'None'} to ${this.checkRideRequest?.PreferredAirportId}`);
    }

    this.initCheckride(checkrideUpdate);

    this.checkForScheduleDateTimeChange(checkrideUpdate);

    this.checkForApplicantChange(checkrideUpdate, variableUpdate);

    this.checkRideTypeId = checkRideRequest.CheckRideTypeId;

    if (!this.checkRideRequest?.CheckRideResult?.CheckRideDateTime &&
      (this.checkRideRequest?.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.Completed
        || this.checkRideRequest?.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingOutcome
      )) {
      this.updateCheckRideResultActualDateTime(checkrideUpdate, variableUpdate);
    }

    if (this.checkRideRequest?.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingOutcome && this.checkRideRequest?.CheckRideResult?.CheckRideOutcomeId) {
      this.updateCheckRideResultActualDateTime(checkrideUpdate, variableUpdate);
    }

    this.checkrideResultActualDateTime = this.checkRideRequest?.CheckRideResult?.CheckRideDateTime;

    this.checkForRebook(checkrideUpdate, variableUpdate);

    this.setAcsTest(checkrideUpdate, variableUpdate);

    this.checkForExaminerChange(checkrideUpdate, variableUpdate);

    this.checkrideForWorkflowChange(checkrideUpdate, variableUpdate);

    this.lastCheckRideRequest = deepCopy(checkRideRequest);
    this.lastVariableContext = deepCopy(variableContext);

    this.updateChanges(checkrideUpdate, variableUpdate);
  }

  checkrideForWorkflowChange(checkrideUpdate: Partial<CheckRideRequestEntity>, variableUpdate: Partial<ExaminerBookingVariableContext>) {
    if (!this.checkRideRequest || !this.lastCheckRideRequest) {
      return;
    }

    if (this.checkRideRequest.CheckRideWorkflowId != this.lastCheckRideRequest?.CheckRideWorkflowId) {
      switch (this.checkRideRequest.CheckRideWorkflowId) {
        case CheckRideWorkflowAllItems.SchoolWorkflow:
          checkrideUpdate.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.PendingApproval;
          console.warn('Setting Checkride Substatus to Pending Approval due to Workflow change');
          break;
        case CheckRideWorkflowAllItems.SchoolWorkflowManualNoPilexosExaminer:
          checkrideUpdate.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.Accepted;
          console.warn('Setting Checkride Substatus to Accepted due to Workflow change');
          break;
      }
    }
  }

  /**
   * Updates the suppress Examiners e-mail flag when the examiner is changed
   * @param checkrideUpdate 
   * @param variableUpdate 
   */
  checkForExaminerChange(checkrideUpdate: Partial<CheckRideRequestEntity>, variableUpdate: Partial<ExaminerBookingVariableContext>) {
    if (!this.checkRideRequest || !this.lastCheckRideRequest) {
      return;
    }

    if (this.checkRideRequest && this.checkRideRequest.FlightSchoolExaminerId != this.lastCheckRideRequest?.FlightSchoolExaminerId) {
      const examiner = this.schoolExaminers.find(e => e.FlightSchoolExaminerId == this.checkRideRequest.FlightSchoolExaminerId);

      if (!examiner) {
        // Shouldn't happen, but let's log it to be sure
        this.dwLoggingService.logWarning(`SchoolCheckRideUtil.checkForExaminerChange - School Examiner not found for ${this.checkRideRequest.FlightSchoolExaminerId}`, null, true);
        return;
      }

      if (checkrideUpdate.ScheduledPilotExaminerId != examiner.PilotExaminerId) {
        checkrideUpdate.ScheduledPilotExaminerId = examiner.PilotExaminerId;
      };

      if (examiner.PilotExaminerId) {
        checkrideUpdate.CheckRideExaminerTypeId = CheckRideExaminerTypeAllItems.Examiner;
      } else {
        checkrideUpdate.CheckRideExaminerTypeId = CheckRideExaminerTypeAllItems.FlightSchoolExaminer;
      }

      let sendCheckrideEmails = false;
      if (examiner.RoFlightSchoolExaminerFinalExaminerTypeId != FlightSchoolExaminerTypeAllItems.PilExOSExaminer) {
        sendCheckrideEmails = examiner.SendCheckrideEmails;
      }

      if (this.checkRideRequest.SendExaminerCheckrideEmails != sendCheckrideEmails) {
        checkrideUpdate.SendExaminerCheckrideEmails = sendCheckrideEmails;
      }
    }
  }


  updateChanges(checkrideUpdate: Partial<CheckRideRequestEntity>, variableUpdate: Partial<ExaminerBookingVariableContext>) {
    const hasCheckrideUpdate = checkrideUpdate && Object.keys(checkrideUpdate).length > 0;
    const hasVariableUpdate = variableUpdate && Object.keys(variableUpdate).length > 0;

    if (!hasCheckrideUpdate && !hasVariableUpdate) {
      return;
    }

    if (checkrideUpdate?.CheckRideTestTypeId) {
      this.schoolDebug('Updating Checkride Test Type - ', checkrideUpdate.CheckRideTestTypeId);
    }

    setTimeout(() => {
      if (hasCheckrideUpdate) {
        //this.schoolDebug('Updating Checkride Data - ', checkrideUpdate);


        this.formApi.patchContextData(DwMdFormContextInfo.DATA_CONTEXT_NAME, checkrideUpdate);
        this.formApi.formGroup.patchValue(checkrideUpdate);
        this.formApi.patchFormData(checkrideUpdate);
      }

      if (hasVariableUpdate) {
        //this.schoolDebug('Updating Checkride Variable Data - ', variableUpdate);
        this.formApi.patchVariableContext(variableUpdate);
        const contextFG = this.formApi.formGroup.get(DwMdFormContextInfo.CONTEXT_FORM_GROUP) as FormGroup;
        const variableContextFG = contextFG.controls[this.formApi.getFormConfig().variableContextDataKey] as FormGroup;
        variableContextFG.patchValue(variableUpdate, { emitEvent: false });
      }
    });
  }

  formActionInterceptor: DwFormActionInterceptor

  setupFormActionInterceptor() {
    this.formActionInterceptor = {
      interceptorName: 'applicantCheckRideUtil',
      order: 1,
      onBeforeActionWait: true,
      onBeforeAction: (actionPref, actionConfig) => {

        // Note: Payment Util form inteceptor runs after this and handles the payment validation (it also saves the checkride before showing the payment modal)
        const result: DwFormActionInterceptResult = {
          abort: false
        }

        if (actionPref.actionKey != DwFormActionKeys.formWorkflow) {
          return of(result);
        }

        const validationResult = this.dwMetaDataFormStateService.state.formApi.validateForm();

        if (!validationResult.isValid) {
          result.abort = true;
          result.message = this.dwMetaDataFormStateService.state.formApi.createValidationMessage(validationResult);

          return of(result);
        }

        const checkrideRequest = this.dwMetaDataFormStateService.state.formApi.getFormData<CheckRideRequestEntity>();

        // We need to validate that the application doesn't have any other active checkrides
        return this.applicantRepositoryService.validateActiveCheckrides(checkrideRequest)
          .pipe(mergeMap(validationResult => {

            if (!validationResult.IsSuccess) {
              result.abort = true;
              result.message = validationResult.Message;

              return of(result);
            }
            // We're all good
            return of(result);
          }));
      }
    }

    // Register the action interceptor with the form
    this.dwMetaDataFormStateService.addActionInterceptor(this.formActionInterceptor);
  }

  checkForApplicantChange(checkrideUpdate: Partial<CheckRideRequestEntity>, variableUpdate: Partial<ExaminerBookingVariableContext>) {
    if (!this.checkRideRequest || !this.lastCheckRideRequest) {
      return;
    }
    const ignoreApplicantDefaults = this.handleApplicantChanges(checkrideUpdate, variableUpdate);

    if (ignoreApplicantDefaults) {
      return;
    }

    if (this.checkRideRequest && this.checkRideRequest.FlightSchoolApplicantId != this.lastCheckRideRequest?.FlightSchoolApplicantId) {
      this.setApplicantDefaults(checkrideUpdate, variableUpdate);

      // // Add defaults for applicant
      // if (!this.applicants) {
      //   this.schoolRepositoryService.getCurrentFlightSchoolApplicants()
      //     .subscribe(applicants => {
      //       this.applicants = applicants;
      //       this.setApplicantDefaults();
      //     });
      // } else {
      //   this.setApplicantDefaults();
      // }
    }
  }

  setApplicantDefaults(checkrideUpdate: Partial<CheckRideRequestEntity>, variableUpdate: Partial<ExaminerBookingVariableContext>) {

    let currentApplicant = this.allApplicants.find(a => a.FlightSchoolApplicantId == this.checkRideRequest.FlightSchoolApplicantId);

    if (checkrideUpdate.FlightSchoolApplicantId) {
      currentApplicant = this.allApplicants.find(a => a.FlightSchoolApplicantId == checkrideUpdate.FlightSchoolApplicantId);
    }

    let clearRebook = this.rebookComplete;

    if (currentApplicant?.FlightSchoolApplicantStatusId == FlightSchoolApplicantStatusAllItems.AwaitingRebook) {
      if (this.variableContext.RebookCheckrideId != currentApplicant.CurrentCheckRideRequestId) {
        this.schoolDebug('Rebooking standard applicant');
        variableUpdate.RebookCheckrideId = currentApplicant.CurrentCheckRideRequestId;
        this.rebookComplete = false;
      }

      // If we're rebooking, we don't want to override with the applicants data
      return;
    }

    if (clearRebook) {
      this.schoolDebug('New applicant is no longer a rebook');

      this.rebookComplete = false;
      variableUpdate.RebookCheckrideId = null;
    }

    if (!currentApplicant) {
      console.warn('Applicant not found for Checkride Applicant Id - ', this.checkRideRequest.FlightSchoolApplicantId);
      return;
    }

    const checkrideApplicantUpdate = this.schoolCheckrideUtilService.updateCheckrideApplicantData(this.checkRideRequest, currentApplicant);

    this.copyProperties(checkrideUpdate, checkrideApplicantUpdate);
    // this.formApi.patchContextData(DwMdFormContextInfo.DATA_CONTEXT_NAME, checkrideUpdate);
    // this.formApi.formGroup.patchValue(checkrideUpdate);
    // this.formApi.patchFormData(checkrideUpdate);
  }

  private initCheckride(checkrideUpdate: Partial<CheckRideRequestEntity>) {
    if (this.initComplete) {
      return;
    }

    this.checkrideScenarioId = this.checkRideRequest?.ScheduledCheckRideScenarioId;
    this.checkRideTypeId = this.checkRideRequest?.CheckRideTypeId;


    this.initComplete = true;


    // Default paymeny party based on school settings
    if (this.schoolFeatures.ForceSchoolPaymentParty && this.schoolFeatures.PilexosBookingCostPaymentPartyId) {
      checkrideUpdate.PilexosBookingCostPaymentPartyId = this.schoolFeatures.PilexosBookingCostPaymentPartyId;

      // this.schoolDebug('Setting Payment Party Id to ', this.schoolFeatures.PilexosBookingCostPaymentPartyId);
    }

    switch(this.schoolFeatures.FlightSchoolTypeId) {
      case FlightSchoolTypeAllItems.Standard:
        checkrideUpdate.CheckRideInstructorTypeId = CheckRideInstructorTypeAllItems.FlightSchoolInstructor; 
        break;
      case FlightSchoolTypeAllItems.ODA:
        checkrideUpdate.CheckRideInstructorTypeId = CheckRideInstructorTypeAllItems.ManualInstructor; 
        break;
    }

    // Check for reschedule info
    this.rescheduleInfo = this.examinerRepositoryService.getCheckrideReferenceInfo(this.checkRideRequest.CheckRideRequestId || -1);

    this.checkrideResultActualDateTime = this.checkRideRequest?.CheckRideResult?.CheckRideDateTime;

    if (this.schoolFeatures.ForceSchoolPaymentParty && this.formApi.formMode == DwFormContextMode.add) {
      checkrideUpdate.PilexosBookingCostPaymentPartyId = this.schoolFeatures.PilexosBookingCostPaymentPartyId;
    }

    if (!this.rescheduleInfo) {
      return;
    }

    if (this.rescheduleInfo.proposedStartDateTime) {
      this.handleReschedule();
      return;
    }

    if (this.rescheduleInfo.startDateTime) {

      checkrideUpdate.ScheduledDateTime = this.rescheduleInfo.startDateTime;

      if (this.rescheduleInfo.durationMinutes) {
        checkrideUpdate.ScheduledTimeMinutes = this.rescheduleInfo.durationMinutes;
      }

      //this.formGroup.patchValue(checkrideUpdate);
    }

  }


  setAcsTest(checkrideUpdate: Partial<CheckRideRequestEntity>, variableUpdate: Partial<ExaminerBookingVariableContext>) {
    if (!this.checkRideRequest?.CheckRideTypeId) {
      return;
    }

    // if (this.checkRideRequest?.ApplicantAcsWrittenResult?.AcsTestId && this.lastCheckRideRequest?.CheckRideTypeId == this.checkRideRequest.CheckRideTypeId) {
    //   return;
    // }

    const acsTestCheckRideType = this.allAcsTests.find(a => a.CheckRideTypeId == this.checkRideRequest.CheckRideTypeId);

    if (!acsTestCheckRideType?.AcsTestId) {
      return;
    }

    let updated = false;

    if (this.checkRideRequest.ApplicantAcsWrittenResult?.AcsTestId != acsTestCheckRideType.AcsTestId) {
      checkrideUpdate.ApplicantAcsWrittenResult = deepCopy(checkrideUpdate.ApplicantAcsWrittenResult) || AppMetaData.ApplicantAcsWrittenResult.CreateEntity();

      //this.schoolDebug('Setting Acs Test from Checkride Type Id - ', this.checkRideRequest.CheckRideTypeId);
      checkrideUpdate.ApplicantAcsWrittenResult.AcsTestId = acsTestCheckRideType.AcsTestId;

      updated = true;
    }

    let newAcsTestId = this.checkRideRequest.ApplicantAcsWrittenResult?.AcsTestId;

    if (updated) {
      newAcsTestId = checkrideUpdate.ApplicantAcsWrittenResult.AcsTestId;
    }

    const showOutcome = this.shouldShowOutcome(this.checkRideRequest.CheckRideRequestSubStatusId);
    // Update the result test
    if (showOutcome && this.checkRideRequest.CheckRideResult.PostApplicantAcsWrittenResult?.AcsTestId != acsTestCheckRideType.AcsTestId) {
      checkrideUpdate.CheckRideResult = deepCopy(this.checkRideRequest.CheckRideResult);

      if (!this.checkRideRequest.CheckRideResult.PostApplicantAcsWrittenResult) {
        checkrideUpdate.CheckRideResult.PostApplicantAcsWrittenResult = AppMetaData.ApplicantAcsWrittenResult.CreateEntity();
      }

      checkrideUpdate.CheckRideResult.PostApplicantAcsWrittenResult.AcsTestId = newAcsTestId;
    }

  }

  private shouldShowOutcome(checkRideRequestSubStatusId: number): boolean {
    const statusIds: number[] = [];

    statusIds.push(CheckRideRequestSubStatusAllItems.PendingOutcome);
    statusIds.push(CheckRideRequestSubStatusAllItems.Completed);

    return statusIds.includes(checkRideRequestSubStatusId);
  }

  updateCheckRideResultActualDateTime(checkrideUpdate: Partial<CheckRideRequestEntity>, variableUpdate: Partial<ExaminerBookingVariableContext>) {
    const checkrideResultUpdate: Partial<CheckRideResultEntity> = {
      CheckRideDateTime: this.checkRideRequest.ScheduledDateTime,
    };

    if (this.checkRideRequest.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.PendingOutcome || this.checkRideRequest.CheckRideRequestSubStatusId == CheckRideRequestSubStatusAllItems.Completed) {

      if (!this.checkRideRequest.CheckRideResult?.CheckRideDateTime) {
        checkrideUpdate.CheckRideResult = checkrideResultUpdate as CheckRideResultEntity;
      }
    }

    // Only update the status if an outcome has been selected
    if (this.checkRideRequest.CheckRideResult.CheckRideOutcomeId) {
      if (this.checkRideRequest.CheckRideRequestSubStatusId != CheckRideRequestSubStatusAllItems.Completed) {
        checkrideUpdate.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.Completed;
      }
    }
  }

  previousScheduleDateTime: string;

  variables = {
    checkride_DateTime_Conflict: 'Checkride_DateTime_Conflict',
    proposed_DateTime_Conflict: 'Proposed_DateTime_Conflict',
  }

  checkForScheduleDateTimeChange(checkrideUpdate: Partial<CheckRideRequestEntity>) {
    if (!this.checkRideRequest) {
      return;
    }

    if (this.previousScheduleDateTime != this.checkRideRequest.ScheduledDateTime) {
      // this.checkCalendarAvailability(this.checkRideRequest.ScheduledDateTime, this.variables.checkride_DateTime_Conflict);
    }

    if (!this.rescheduleInfo) {
      return;
    }

    if (this.rescheduleInfo.proposedStartDateTime) {
      return;
    }

    if (this.rescheduleInfo.startDateTime) {
      if (this.checkRideRequest.ScheduledDateTime != this.rescheduleInfo.startDateTime) {
        checkrideUpdate.ScheduledDateTime = this.rescheduleInfo.startDateTime;
        //this.formGroup.patchValue(this.checkRideRequest);
      }
    }
  }

  rebookComplete?: boolean;
  rebookCompleteCheckrideId?: number;

  checkForRebook(checkrideUpdate: Partial<CheckRideRequestEntity>, variableUpdate: Partial<ExaminerBookingVariableContext>) {
    if (this.rebookComplete || this.dwMetaDataFormStateService.state.formContext.contextMode != DwFormContextMode.add) {
      return;
    }

    // We want to wait until the defaults have been loaded
    if (!this.dwMetaDataFormStateService.state.formContext.defaultsProcessed) {
      return;
    }

    if (!this.variableContext?.RebookCheckrideId) {

      if (this.rebookCompleteCheckrideId) {
        console.warn(`Clearing rebookCompleteCheckrideId of ${this.rebookCompleteCheckrideId}`);

        this.rebookCompleteCheckrideId = null;
      }
      return;
    }

    // We've already setup this checkride, so let's not do it again!
    if (this.variableContext.RebookCheckrideId == this.rebookCompleteCheckrideId) {
      return;
    }

    this.rebookComplete = true;
    this.isRebook = true;

    this.rebookCompleteCheckrideId = this.variableContext?.RebookCheckrideId;

    this.schoolRepositoryService.getRebookCheckrideRequest(this.variableContext.RebookCheckrideId)
      .subscribe(checkride => {
        // Wait a half second to make sure the form is loaded
        setTimeout(() => {
          this.updateCheckrideForRebook(checkride);
        });
      });
  }

  updateCheckrideForRebook(checkride: CheckRideRequestEntity) {
    if (!checkride) {
      return;
    }
    this.rebookComplete = true;

    const updatedCheckride = this.examinerRepositoryService.prepareCheckrideForCopy(checkride, this.testTypes, this.outcomes);

    let waivePayment = this.examinerRepositoryService.getWaiveCheckridePaymentOnRebook(checkride);

    // Set the preferred pilot examiner to the same as before
    const udpatedVariables: Partial<ExaminerBookingVariableContext> = {
      Pilexos_Payment_Waived: waivePayment,
      RebookCheckrideId: checkride.CheckRideRequestId,
      BookMultiple: false
    };

    //this.formApi.patchVariableContext(variables);

    updatedCheckride.PilexosBookingPaymentAdded = waivePayment;

    // Clear scheduled fields
    updatedCheckride.ScheduledDateTime = null;

    if (this.hasSchoolFreeTrial()) {
      updatedCheckride.PilexosBookingPaymentAdded = true;
    } else {
      if (checkride.CheckRideResult?.RetestCost) {
        updatedCheckride.ScheduledCheckRideCost = checkride.CheckRideResult?.RetestCost;
      }

      if (!this.checkRideRequest.CheckRideRequestSubStatusId) {
        updatedCheckride.CheckRideRequestSubStatusId = CheckRideRequestSubStatusAllItems.PendingApprovalPayment;
      }
    }

    // Set these fields so it doesn't get overritten by the scenario logic
    this.checkRideTypeId = checkride.CheckRideTypeId;
    this.checkrideScenarioId = checkride.ScheduledCheckRideScenarioId;

    //this.formApi.patchFormData(updatedCheckride);

    this.schoolDebug('Rebook update', updatedCheckride, udpatedVariables);

    this.updateChanges(updatedCheckride, udpatedVariables);
  }


  private hasSchoolFreeTrial(): boolean {
    return this.schoolFeatures?.SchoolFeatures?.find(f => f == SchoolFeatureAllItems.SchoolBookingFeeFreeTrial) != null;
  }

  private handleReschedule() {
    const scheduleUTCDateTime = formatDateTimeFromLocal(this.rescheduleInfo.proposedStartDateTime, true, true);

    switch (this.checkRideRequest.CheckRideRequestSubStatusId) {
      case CheckRideRequestSubStatusAllItems.PendingApproval:
      case CheckRideRequestSubStatusAllItems.PendingApprovalPayment:
      case CheckRideRequestSubStatusAllItems.NewDateProposedByExaminer:
      case CheckRideRequestSubStatusAllItems.RequiresAdditionalInfo:
      case CheckRideRequestSubStatusAllItems.RequiresAdditionalInfo:
        break;

      default:
        return;
    };

    const partialCheckRequestRequest: Partial<CheckRideRequestEntity> = {
      ProposedDateTime: scheduleUTCDateTime,
      ProposedAirportId: this.checkRideRequest.ScheduledAirportId,
      ProposedTimeMinutes: this.checkRideRequest.ScheduledTimeMinutes,
      CheckRideRequestSubStatusId: CheckRideRequestSubStatusAllItems.NewDateProposedByExaminer
    };

    this.checkRideRequest.CheckRideRequestSubStatusId = partialCheckRequestRequest.CheckRideRequestSubStatusId;

    this.updateChanges(partialCheckRequestRequest, null);

    // // Patch the form data
    // this.formApi.patchFormData(partialCheckRequestRequest);
  }

  private updateProposedInfo(checkRideRequest: CheckRideRequestEntity) {

    const partialCheckRequestRequest: Partial<CheckRideRequestEntity> = {
      ProposedDateTime: checkRideRequest.ScheduledDateTime,
      ProposedAirportId: checkRideRequest.ScheduledAirportId,
      ProposedTimeMinutes: checkRideRequest.ScheduledTimeMinutes,
    };

    // Patch the form data
    this.updateChanges(partialCheckRequestRequest, null);
    //this.formApi.patchFormData(partialCheckRequestRequest);
  }

  lastApplicantIds: string = '';

  private handleApplicantChanges(checkrideUpdate: Partial<CheckRideRequestEntity>, variableUpdate: Partial<ExaminerBookingVariableContext>): boolean {

    if (!this.checkRideRequest || !this.variableContext || !this.allApplicants) {
      return;
    }

    // Check if fields have changed
    const attrs = AppMetaData.CheckRideRequest.Attributes;

    if (!this.hasChanges(this.checkRideRequest, this.lastCheckRideRequest, attrs.FlightSchoolApplicantId) && !this.hasVariableContextChanges()) {

      // Double check to see if applicants are selected then haven't been processed.  (variable context could have been updated before first check)
      if (this.variableContext.Applicants == null || this.variableContext.Applicants === this.lastApplicantIds) {
        return;
      }
    }
    this.lastApplicantIds = this.variableContext.Applicants;

    // Current Applicant
    let applicant = this.allApplicants.find(a => a.FlightSchoolApplicantId === this.checkRideRequest.FlightSchoolApplicantId);



    if (this.variableContext?.BookMultiple && this.variableContext?.Show_Search && this.checkRideRequest.CheckRideWorkflowId == CheckRideWorkflowAllItems.SchoolWorkflow) {
      if (!this.variableContext?.Applicants) {
        return;
      }

      const applicantIds = this.variableContext.Applicants.split(',').map(id => parseInt(id, 10));

      //const applicants = this.allApplicants.filter(a => applicantIds.includes(a.FlightSchoolApplicantId));
      const applicants = applicantIds.map(id => this.allApplicants.find(a => a.FlightSchoolApplicantId === id)).filter(a => a != null);

      if (applicantIds.length === 0) {
        return;
      }

      const result = this.validateApplicants(applicants);

      this.errorMessage = result.message;
      this.showError = !result.isValid;

      if (!result.isValid) {

        if (this.variableContext.ApplicantsAreInvalid) {
          variableUpdate.ApplicantsAreInvalid = true;
        }
        return;
      }

      if (this.variableContext.ApplicantsAreInvalid) {
        variableUpdate.ApplicantsAreInvalid = false;
      }

      if (result.applicantRef) {
        applicant = result.applicantRef;
      } else {
        applicant = applicants[0];
      }
    }

    if (applicant) {
      this.schoolDebug(`Handle Applicant Changes ${applicant?.ApplicantName || 'Blank'}`);

      if (applicant.FlightSchoolApplicantStatusId == FlightSchoolApplicantStatusAllItems.AwaitingRebook && applicant.CurrentCheckRideRequestId) {
        this.schoolDebug(`Handle Applicant Rebooking for  ${applicant.CurrentCheckRideRequestId || 'Blank'}`);

        if (this.variableContext.RebookCheckrideId == applicant.CurrentCheckRideRequestId) {
          return;
        }

        variableUpdate.RebookCheckrideId = applicant.CurrentCheckRideRequestId;
        this.rebookComplete = false; // Reset this since it could be for a different applicant
        return;
      }

      const checkrideUpdateSub: Partial<CheckRideRequestEntity> = {
        CheckRideGroupId: applicant.CheckRideGroupId,
        CheckRideTypeId: applicant.CheckRideTypeId,
        CheckRideTestTypeId: applicant.CheckRideTestTypeId,
        FlightSchoolApplicantId: applicant.FlightSchoolApplicantId,
        //PreferredDateTime: applicant.ExpectedCheckrideDateTime,
      };

      if (checkrideUpdateSub?.CheckRideTestTypeId) {
        this.schoolDebug(`Setting CheckRideTestTypeId: ${checkrideUpdateSub.CheckRideTestTypeId}`);
      }

      if (applicant.FlightSchoolApplicantBranch?.length > 0) {
        const location = applicant.FlightSchoolApplicantBranch[0];

        if (location?.FlightSchoolBranch?.MainAirportId) {
          checkrideUpdateSub.PreferredAirportId = location.FlightSchoolBranch.MainAirportId;
        }
      }

      if (applicant.FlightSchoolBranch?.MainAirportId) {
        checkrideUpdateSub.PreferredAirportId = applicant.FlightSchoolBranch.MainAirportId;
      }


      let noChanges = (this.checkRideRequest?.CheckRideGroupId == applicant.CheckRideGroupId &&
        this.checkRideRequest?.CheckRideTypeId == applicant.CheckRideTypeId &&
        this.checkRideRequest?.CheckRideTestTypeId == applicant.CheckRideTestTypeId &&
        //this.checkRideRequest?.PreferredDateTime == applicant.ExpectedCheckrideDateTime &&
        this.checkRideRequest?.PreferredAirportId == checkrideUpdateSub?.PreferredAirportId &&
        this.checkRideRequest?.FlightSchoolApplicantId == checkrideUpdateSub?.FlightSchoolApplicantId
      );

      if (noChanges) {
        return;
      }

      //this.schoolDebug('Applicant Change Detected - Updating Checkride Data - ', checkrideUpdateSub);

      this.copyProperties(checkrideUpdate, checkrideUpdateSub);

      if (this.checkRideRequest?.FlightSchoolApplicantId != checkrideUpdateSub?.FlightSchoolApplicantId) {
        this.setApplicantDefaults(checkrideUpdate, variableUpdate);

        // Update this here so it doesn't trigger a second update
        this.checkRideRequest.FlightSchoolApplicantId = checkrideUpdateSub?.FlightSchoolApplicantId;

        return true;
      }

      return false;
      // setTimeout(() => {
      //   this.formApi.patchFormData(checkrideUpdate);
      // }, 100);
    }
  }

  validateApplicants(applicants: FlightSchoolApplicantEntity[]): { isValid: boolean, applicantRef?: FlightSchoolApplicantEntity, message?: string } {
    // Ensure all applicants have the same CheckRideGroupId
    const result: { isValid: boolean, applicantRef?: FlightSchoolApplicantEntity, message?: string } = {
      isValid: true,
      applicantRef: null,
    };

    // Get the first applicant that has a CheckRideTypeId
    result.applicantRef = applicants.find(a => a.CheckRideTypeId);

    if (!result.applicantRef) {
      return result;
    }

    const messages: string[] = [];

    for (const applicant of applicants) {
      if (applicant.CheckRideTypeId && applicant.CheckRideTypeId !== result.applicantRef.CheckRideTypeId) {
        messages.push(`Applicant ${applicant.ApplicantName} is for ${applicant.CheckRideGroupIdDisplay} - ${applicant.CheckRideTypeIdDisplay}`);
      }
    }

    if (messages.length > 0) {

      messages.unshift(`Applicant ${result.applicantRef.ApplicantName} is for ${result.applicantRef.CheckRideGroupIdDisplay} - ${result.applicantRef.CheckRideTypeIdDisplay}`);
      const list = '<ul>' + messages.map(m => `<li>${m}</li>`).join('') + '</ul>'

      result.message = `All applicants must be for the same Grade & Category! <br> ${list}`;
      result.isValid = false;
    }

    return result;
  }

  hasVariableContextChanges(): boolean {
    if (this.variableContext?.BookMultiple != this.lastVariableContext?.BookMultiple ||
      (this.variableContext?.BookMultiple && this.variableContext?.Applicants != this.lastVariableContext?.Applicants)) {
      return true;
    }

    return false;
  }

  hasChanges(current: any, last: any, ...attrs: DwItemAttribute[]): boolean {
    if (!current) {
      return false;
    }

    if (!last) {
      return true;
    }

    for (const attr of attrs) {
      if (current[attr.fieldName] !== last[attr.fieldName]) {
        return true;
      }
    }

    return false;
  }

  copyProperties(target: any, source: any) {

    if (!target) {
      return;
    }

    for (const key of Object.keys(source)) {
      target[key] = source[key];
    }
  }

  enableDebug = true;

  private schoolDebug(message: string, ...optionalParams: any[]) {
    if (this.enableDebug) {
      console.debug(`School Debug: ${message}`, ...optionalParams);
    }
  }

}